import {emptyValidator, formValidator} from "../../validators";

const userCustomerValidatorStatus ={
    uscUserId: {
        validators: [emptyValidator()],
        name: "User ",
    },
    uscStkType: {
        validators: [emptyValidator()],
        name: "Stakeholder Type ",
    },
    uscStakeholder: {
        validators: [emptyValidator()],
        name: "Stakeholder ",
    },
    uscActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
    uscStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
};
export const UserCustomerValidation = (userCustomerData) => {
    return formValidator(userCustomerData, userCustomerValidatorStatus);
};
